import { Box } from '@/common/components';
import { styled } from '@/stitches.config';
import { ReactComponent as ArrowRight } from '@assets/icons/arrow-right.svg';

export const StyledContainer = styled(Box, {
  backgroundColor: '$seafoam800',
  borderRadius: '$4',
  display: 'flex',
  flexDirection: 'column',
  padding: '$8',
  alignItems: 'flex-start',
  justifyContent: 'flex-start'
});

export const StyledMessage = styled('span', {
  color: '$darkBlue300',
  fontSize: '$2xl',
  fontWeight: '$bold',
  lineHeight: '$8',
  marginBottom: '$8',
  textAlign: 'left'
});

export const StyledArrowIcon = styled(ArrowRight, {
  height: '$6',
  marginLeft: '$1',
  width: '$6',
});
